import m from 'mithril'

export default {
  view: vnode => {
    const image = require('./image14.jpg')
    const screenshot = require('./screenshot.jpg')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-10-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">Hvis Krigen kommer</h3>
          <p className="log-book-text">
          Pjece omdelt til alle danske husstande i 1962. Indeholder instrukser om, hvad man skal gøre, hvis der kommer atomkrig. Søg i beskyttelsesrum og sørg for nødforsyning til 8 dage!
          </p>

          <p className="log-book-text">Til én person:</p>
          <ul className="log-book-text">
            <li>5 dåser minutkød á ca 340 g</li>
            <li>3 dåser frikadeller i fedt (ikke sovs) á ca. 300 g</li>
            <li>2 pakker knækbrød (á 30 stk.) á 200 g. </li>
            <li>3 pakker kiks (á 30 stk.) á 250 g</li>
            <li>8 plader chokolade á 40 g  </li>
            <li>1 pakke rosiner á 340 g</li>
            <li>100 g melis = 40 stk. sukker</li>
            <li>1 dåse bordsalt </li>
          </ul>
          <figure className="log-book-figure">
            <img src={image} className="log-book-img" />
          </figure>
          <figure className="log-book-figure">
            <img src={screenshot} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            “Den nye virkning ved kernevåben er radioaktiviteten. Den ligner de stråler, der bruges ved røntgenbehandling, men kan være så kraftig, at den virker dræbende eller kan medføre varige skader, også ud over den generation, der rammes.”
            </figcaption>
          </figure>
          
        </div>
      </div>
    )
  }
}
